import type { Network } from '@mogul/api-client';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

import { emailApi } from '../../../api';
import emailIcon from '../../../common/svg/general/icon_mail.svg';
import { ReactComponent as XIcon } from '../../../common/svg/general/icon-x.svg';
import { validEmailRegexForNotify } from '../../../constants/regexs';
import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './SignupDropNotifyModal.module.css';

interface Props {
  hideModal: () => void;
  onClick?: () => void;
  // buttonText?: string;
  collectionContractAddress?: string;
  collectionNetwork?: Network;
}

interface SignupModalProps {
  hideModal: () => void;
}

const SignupDropNotifyModalContainer: React.FC<Props> = ({
  hideModal,
  collectionContractAddress,
  collectionNetwork,
}: Props) => {
  const [email, updateEmail] = useState('');
  const [isEmail, setIsEmail] = useState(false);

  const handleOnChange = (inputEmail: string) => {
    if (validEmailRegexForNotify.test(inputEmail)) {
      updateEmail(inputEmail);
      setIsEmail(true);
    } else {
      setIsEmail(false);
    }
  };

  const useEmailSubmit = async () => {
    try {
      await emailApi.addNotifyByEmail({
        email,
        emailNotificationData: { collectionContractAddress, collectionNetwork },
      });
      toast.success('Enabled drop notifications');
      sessionStorage.setItem('dropNotify', 'true');
      hideModal();
    } catch (e) {
      toast.error('There was an error, try again later');
    }
  };

  return (
    <div className={`${styles.signupModal} sm:max-w-sm max-w-xs relative`}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={styles.xIconBG} onClick={hideModal}>
        <XIcon className={styles.xIcon} />
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-center">
          <h1 className={`${styles.emailTitle} p-0 m-0 relative`}>
            Get Notified
          </h1>
        </div>
        <div className="items-center pt-5 pl-4">
          <img src={emailIcon} alt="" />
        </div>
        <p className={styles.caption}>
          Be the first to hear about the latest drops, updates and special
          offers from Mogul Productions!
        </p>
        <input
          type="email"
          maxLength={150}
          className={`${styles.emailInputs} w-full py-3 pl-3 my-3`}
          placeholder="example@email.com"
          onChange={e => handleOnChange(e.target.value)}
        />
        <Button
          color={Colors.COLOR_SCHEME_2}
          className={`${styles.signupBtn}`}
          onClick={useEmailSubmit}
          disabled={!isEmail}
        >
          SUBSCRIBE
        </Button>
      </div>
    </div>
  );
};

export const SignupModal =
  (
    onClick?: () => void,
    collectionContractAddress?: string,
    collectionNetwork?: Network,
  ) =>
  ({ hideModal }: SignupModalProps) => {
    return (
      <SignupDropNotifyModalContainer
        hideModal={hideModal}
        onClick={onClick}
        collectionContractAddress={collectionContractAddress}
        collectionNetwork={collectionNetwork}
      />
    );
  };
